import { TieredMenu } from 'primeng/tieredmenu'

import { checkIsElementAttached } from '../../layout/utils'

export function patchTieredMenu() {
  /**
   * Patch the TieredMenu hide method to fix stale overlays due to custom route reuse
   *
   * PrimeNG overlays attach their content to a separate part of the DOM (outside the Angular component tree)
   * When using a custom route reuse strategy, the normal component destruction does not occur,
   * so the overlay may remain visible in the DOM even though its component is detached
   */
  const orig__TieredMenu_hide = TieredMenu.prototype.hide
  TieredMenu.prototype.hide = function (...args) {
    orig__TieredMenu_hide.call(this, ...args)

    setTimeout(() => {
      if (!checkIsElementAttached(this.el.nativeElement)) {
        this.cd.detectChanges()
      }
    }, 32)
  }
}
